import {isFeatureEnabled} from '@github-ui/feature-flags'
import {constructSharedWorker, constructWorker} from '@github-ui/trusted-types/worker'

export function createWorker(url: string, options?: WorkerOptions): Worker {
  // TODO: https://github.com/github/react-platform/issues/2347: Remove the native rollback path before Trusted Types enforcement.
  // eslint-disable-next-line @github-ui/github-monorepo/require-worker-construction -- Temporary report-only rollback path.
  if (!isFeatureEnabled('trusted_types_worker')) return new Worker(url, options)
  return constructWorker(url, options)
}

export function createSharedWorker(url: string, options?: string | WorkerOptions): SharedWorker {
  // TODO: https://github.com/github/react-platform/issues/2347: Remove the native rollback path before Trusted Types enforcement.
  // eslint-disable-next-line @github-ui/github-monorepo/require-worker-construction -- Temporary report-only rollback path.
  if (!isFeatureEnabled('trusted_types_worker')) return new SharedWorker(url, options)
  return constructSharedWorker(url, options)
}
